import {PII_FIELD_RULES_FAILURE, PII_FIELD_RULES_REQUEST, PII_FIELD_RULES_SUCCESS} from '../actions/fieldRules';

export type FieldRulesState = {
  status: string;
  rules: FieldRules;
  statusResponse: $TSFixMe;
};

const initialState = {};

export default function piiFieldRules(state = initialState, action = null): FieldRulesState | {} {
  // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
  switch (action.type) {
    case PII_FIELD_RULES_REQUEST:
      return Object.assign({}, state, {status: PII_FIELD_RULES_REQUEST});
    case PII_FIELD_RULES_SUCCESS:
      // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
      return Object.assign({}, state, {status: PII_FIELD_RULES_SUCCESS, rules: action.payload});
    case PII_FIELD_RULES_FAILURE:
      // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
      return Object.assign({}, state, {status: PII_FIELD_RULES_FAILURE, statusResponse: action.error});
    default:
      return state;
  }
}
